import DashboardActive from "../../assets/redesign/dashboardActive.svg";
import Dashboard from "../../assets/redesign/dashboardLogo.svg";
import Placements from "../../assets/redesign/job-link.svg";
import PlacementsActive from "../../assets/redesign/placementsActive.svg";
import Job from "../../assets/redesign/permanent-job.svg";
import JobActive from "../../assets/redesign/jobsActive.svg";
import search from "../../assets/redesign/search-01.svg";
import searchActive from "../../assets/redesign/searchActive.svg";

import Logout from "../../assets/redesign/logoutLogo.svg";
import profile from "../../assets/redesign/settings.svg";
import profileActive from "../../assets/redesign/settingsActive.svg";
import { PreSigned } from "../../models/application";

export const adminMenuItems = [
  {
    Name: "Dashboard",
    Icon: Dashboard,
    activeIcon: DashboardActive,
    Link: "/dashboard",
  },

  {
    Name: "Jobs & Applications",
    Icon: Job,
    activeIcon: JobActive,
    Link: "/dashboard/jobsposted",
  },
  {
    Name: "Placements",
    Icon: Placements,
    activeIcon: PlacementsActive,
    Link: "/dashboard/placements",
  },
  {
    Name: "Search Database",
    Icon: search,
    activeIcon: searchActive,
    Link: "/searchcv",
  },
];

export const additionalMenuItems = [
  {
    Name: "Settings",
    Icon: profile,
    activeIcon: profileActive,
    Link: "/dashboard/settings",
    // isDrawer: true,
    // component: <ProfileSettings />,
  },
  {
    Name: "Logout",
    Icon: Logout,
    Link: "#",
  },
];

export const baseUrl = "";

// export   const Token = localStorage.getItem('userId')
// export   const CompanyId = localStorage.getItem('companyId');
// export const userId = localStorage.getItem('Id');

export const populateFormDataWithType = (
  formData: FormData,
  contentUploadResp: PreSigned | undefined,
  file: Blob | File
) => {
  formData.append(
    "x-amz-meta-userid",
    contentUploadResp?.fields["x-amz-meta-userid"]!
  );
  formData.append("Content-Type", file.type);
  formData.append("key", contentUploadResp?.fields.key!);
  formData.append("bucket", contentUploadResp?.fields.bucket!);
  formData.append(
    "X-Amz-Algorithm",
    contentUploadResp?.fields["X-Amz-Algorithm"]!
  );
  formData.append(
    "X-Amz-Credential",
    contentUploadResp?.fields["X-Amz-Credential"]!
  );
  formData.append("X-Amz-Date", contentUploadResp?.fields["X-Amz-Date"]!);
  formData.append(
    "X-Amz-Security-Token",
    contentUploadResp?.fields["X-Amz-Security-Token"]!
  );
  formData.append(
    "X-Amz-Signature",
    contentUploadResp?.fields["X-Amz-Signature"]!
  );
  formData.append("Policy", contentUploadResp?.fields.Policy!);
  formData.append("file", file!);
};
